import styled, { css } from 'styled-components';

import SelectInput from 'Elements/Input/Select';
import ResetButton from 'Elements/Button/Reset';

export const Container = styled.div`
    ${({ theme }) => css`
        background: ${theme.colors.secondary.tints[1].hex};
        padding: 1rem 0rem 0rem;
    `}
`;

export const StyledForm = styled.form`
    ${({ theme }) => css`
        margin-bottom: 1rem;

        @media ${theme.breakpoints.medium.media} {
            margin-bottom: 2.5rem;
            text-align: unset;
            display: flex;
            justify-content: space-between;
        }
    `}
`;

export const SearchWrapper = styled.div`
    flex: 1;
`;

export const StyledSelectInput = styled(SelectInput)`
    ${({ theme }) => css`
        margin-top: 1rem;
        flex: 1;

        @media ${theme.breakpoints.medium.media} {
            margin: 0 1.25rem;
        }
    `}
`;

export const StyledResetButton = styled(ResetButton)`
    ${({ theme }) => css`
        background: ${theme.colors.secondary.hex};

        && {
            width: 10rem;
            margin-top: 1rem;
            height: 2.5rem;
            align-self: flex-end;

            @media ${theme.breakpoints.large.media} {
                height: auto;
            }
        }
    `}
`;
